import React from 'react';

import svg from './assets/icons-16-checkmark.svg';
import type { IconProps } from './SvgIcon';
import { SvgIcon } from './SvgIcon';

export const IconCheckmark = (props: IconProps) => (
  <SvgIcon {...props} src={svg} testId="icon-checkmark" />
);
